module Core {
    export enum ConviveTypeContrat {
        Interne = 1,
        Externe = 2
    }
}